import { InjectionToken } from '@angular/core';
import { CacheService } from '../services/cacheInterface';

export const CACHE_SERVICE = new InjectionToken<CacheService>('CacheService');
export const SSRLOGGER = new InjectionToken<any>('SSRLogger');
